import { fromJS } from 'immutable'
import { Actions } from './compound-settings.actions'
import * as CompoundSettingsTypes from './compound-settings.types'

export const initialState = fromJS<any>({
  isLoading: false,
  validationErrors: {},
  data: {},
})

export function compoundSettingsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case CompoundSettingsTypes.UPDATE_COMPOUND_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case CompoundSettingsTypes.UPDATE_COMPOUND_SETTINGS_SUCCESS: {
      return state.set('isLoading', false)
    }

    case CompoundSettingsTypes.UPDATE_COMPOUND_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case CompoundSettingsTypes.FETCH_COMPOUND_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case CompoundSettingsTypes.FETCH_COMPOUND_SETTINGS_SUCCESS: {
      return state.set('isLoading', false).set('data', fromJS(action.payload))
    }

    case CompoundSettingsTypes.FETCH_COMPOUND_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case CompoundSettingsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case CompoundSettingsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
